var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,384.7L941.3,186l-12.1-53.6c-3.4-15.2-18.8-24.8-33.9-21.4l-821,184.9c-15.2,3.4-24.8,18.6-21.4,33.9 C57,348,61,366.5,65.2,384.7L65.2,384.7z M57.9,247.4L889.4,60.3c39.7-8.9,79.2,16.1,88.1,55.7l87.1,385.1h-52.1L973,326.7 L96.9,525.4l54.2,239.1l4.9,21.2c1.9,8.5,10.4,14,19,12l6.5-1.5v51l-0.9,0.3c-32.9,7.4-65.7-13.5-73.2-46.3L1.9,335.6 c-4.5-19.8-1.2-38.4,9.6-55.7C22.3,262.6,38.1,251.8,57.9,247.4L57.9,247.4z M273.7,515c-40.6,0-73.6,33.2-73.6,73.8v479.1 c0,40.6,33,73.6,73.6,73.6h852.5c40.6,0,73.8-33.2,73.8-73.6V588.8c0-40.6-33.2-73.8-73.8-73.8H273.7z M1108.3,729.4v-97.5 c0-6.3-5-11.3-11.3-11.3H878.8c-6.2,0-11.3,5.1-11.3,11.3v97.5c0,6.2,5.1,11.3,11.3,11.3H1097C1103,740.8,1108.3,735.8,1108.3,729.4 z M947.5,1025.1c-6.3,0-11.5-5.1-11.5-11.3v-22.7c0-6.2,5.1-11.3,11.5-11.3h149.3c6.2,0,11.3,5.1,11.3,11.3v22.7 c0,6.2-5.1,11.3-11.3,11.3H947.5z M739.1,1025.1c-6.2,0-11.3-5.1-11.3-11.3v-22.5c0-6.3,5.1-11.3,11.3-11.3h149.5 c6.2,0,11.3,5.1,11.3,11.3v22.5c0,6.2-5.1,11.3-11.3,11.3H739.1z M530.8,1025.1c-6.2,0-11.3-5.1-11.3-11.3v-22.5 c0-6.3,5.1-11.3,11.3-11.3h149.5c6.2,0,11.3,5.1,11.3,11.3v22.5c0,6.2-5.1,11.3-11.3,11.3H530.8z M322.6,1025.1 c-6.2,0-11.3-5.1-11.3-11.3v-22.5c0-6.3,5.1-11.3,11.3-11.3H472c6.2,0,11.3,5.1,11.3,11.3v22.5c0,6.2-5.1,11.3-11.3,11.3H322.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOps);
export default __webpack_public_path__ + "static/media/ops.876bad0414860f4ba7e2b4ec64381215.svg";
export { ForwardRef as ReactComponent };